module.exports = __webpack_public_path__ + "img/as_loading.2589e4e8.svg";